<main-header *ngIf="facade.isLoggedIn$ | async"></main-header>
<div class="error-page-content">
  <error-screen [isShowErrorCode]="false"></error-screen>
</div>
